import { useState, useEffect } from 'react';
import { DateTime } from "luxon";

import { resolveTimeCounterIntervalMs } from './timeCounterInterval';

type Props = {
  startedAt?: DateTime;
  endedAt?: DateTime | null;
  decimals?: number; // default 1
};

export default function TimeCounter({startedAt, endedAt, decimals = 1}: Props) {
  const [now, setNow] = useState(() => DateTime.now());

  // tick while no endedAt (live counter)
  useEffect(() => {
    if (endedAt) return;
    const id = window.setInterval(() => setNow(DateTime.now()), resolveTimeCounterIntervalMs(decimals));
    return () => clearInterval(id);
  }, [endedAt, decimals]);

  if (!startedAt) return <span/>;

	const end = endedAt === null ? null : endedAt === undefined ? now : endedAt;
  const diffHours = end === null ? 0 : Math.max(0, end.diff(startedAt).as('hours'));

  return (
    <span>
    { end === null ? '-' :
      diffHours.toLocaleString(undefined, {
          minimumFractionDigits: decimals,
          maximumFractionDigits: decimals
        }
      )
    }
    </span>
  );
}
